<template>
  <article class="modal">
    <component
      :is="modalStore.fullScreenModalState.component"
      v-bind="modalStore.fullScreenModalState.props"
      @close="modalStore.closeFullScreenModal"
      @go-back="modalStore.goBackFullScreenModal"
    />
  </article>
</template>

<script setup lang="ts">
  import { useModalStore } from '@/stores/modal';

  const modalStore = useModalStore();
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: vars.$z-index-full-screen-modal;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
</style>
